import { createContext } from "react";
import type { Breakpoint } from "./types";

export const BreakpointContext = createContext<Breakpoint | null>(null);
